import { ReactNode } from 'react';

import Text from '../base/TextNew';

export interface EmptyStateProps {
  title?: ReactNode;
  description: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
  align?: 'center' | 'start';
  borderStyle?: 'solid' | 'dashed' | 'none';
}

export default function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  align = 'center',
  borderStyle = 'solid',
}: EmptyStateProps) {
  const isCentered = align === 'center';

  return (
    <div
      className={`border-primary rounded-lg ${
        borderStyle === 'none'
          ? ''
          : borderStyle === 'dashed'
            ? 'border border-dashed'
            : 'border'
      } p-4 ${className ?? ''}`}
    >
      <div
        className={`flex flex-col gap-4 ${
          isCentered ? 'items-center text-center' : 'items-start text-left'
        }`}
      >
        {icon ? <div className="text-tertiary">{icon}</div> : null}

        <div
          className={`flex flex-col gap-4 ${
            isCentered ? 'items-center' : 'items-start'
          }`}
        >
          {title ? (
            <Text
              as="h3"
              token="14/medium"
              className="text-tertiary text-pretty"
            >
              {title}
            </Text>
          ) : null}

          <Text as="div" token="14" className="text-tertiary text-pretty">
            {description}
          </Text>
        </div>

        {action ? <div className="flex">{action}</div> : null}
      </div>
    </div>
  );
}
